import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import api from '@/venit/components/cortona-venit/services/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'PostRegistrationTooltip',
  props: {
    token: {},
    email: {}
  },
  setup(__props: any) {

const props = __props;

const resendDisabled = ref(false);

const resend = () => {
  resendDisabled.value = true;
  setTimeout(() => (resendDisabled.value = false), 30000);
  api.activationResend(props.token);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, { type: "success" }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('profile.registration.success')) + " ", 1 /* TEXT */),
      _createElementVNode("b", null, _toDisplayString(__props.email), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createTextVNode(". ", -1 /* CACHED */)),
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        class: "mt-3 clickable",
        disabled: resendDisabled.value,
        onClick: resend
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-3" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-send", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('profile.registration.resend')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})